// The HTTP object used to be called Meteor.http.
// XXX COMPAT WITH 0.6.4
Meteor.http = HTTP;
